<template>
  <div
    class="input-box"
    ref="input_box"
    v-loading="loading"
    element-loading-background="#FAFAFA"
    v-bind:class="{
      focused: isFocused,
      blurd: !isFocused,
      expanded: show_all,
      hasFiles: fileList.length > 0,
    }"
    v-on:keydown.meta.enter="onSubmitByHotkey('Meta+Enter')"
    v-on:keydown.ctrl.enter="onSubmitByHotkey('Ctrl+Enter')"
    v-on:keydown.shift.enter="onSubmitByHotkey('Shift+Enter')"
    v-on:keydown.enter.exact="onSubmitByHotkey('Enter')"
  >
    <bubble-menu :editor="editor" v-if="editor" class="bubble-menu">
      <div class="wrap">
        <button
          @click.stop="editor.chain().focus().toggleBold().run()"
          :class="{ 'is-active': editor.isActive('bold') }"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '气泡菜单-加粗',
          }"
        >
          <svg-icon :iconClass="'bold'"></svg-icon>
        </button>
        <button
          @click.stop="editor.chain().focus().toggleUnderline().run()"
          :class="{ 'is-active': editor.isActive('underline') }"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '气泡菜单-下划线',
          }"
        >
          <svg-icon :iconClass="'underline'"></svg-icon>
        </button>
        <!-- <button
          @click.stop="editor.chain().focus().toggleStrike().run()"
          :class="{ 'is-active': editor.isActive('strike') }"
        >
          <svg-icon :iconClass="'strike'"></svg-icon>
        </button> -->
        <button
          @click.stop="editor.chain().focus().toggleHighlight().run()"
          :class="{ 'is-active': editor.isActive('highlight') }"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '气泡菜单-高亮',
          }"
        >
          <svg-icon :iconClass="'mark'"></svg-icon>
        </button>
        <span class="vertical-line" style="width: 1px; height: 18px; margin: 10px"></span>
        <button
          @click.stop="editor.chain().focus().toggleBulletList().run()"
          :class="{ 'is-active': editor.isActive('bulletList') }"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '气泡菜单-无序列表',
          }"
        >
          <svg-icon :iconClass="'ul'"></svg-icon>
        </button>
        <button
          @click.stop="editor.chain().focus().toggleOrderedList().run()"
          :class="{ 'is-active': editor.isActive('orderedList') }"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '气泡菜单-有序列表',
          }"
        >
          <svg-icon :iconClass="'ol'"></svg-icon>
        </button>
        <!-- <button
          @click.stop="editor.chain().focus().toggleBlockquote().run()"
          :class="{ 'is-active': editor.isActive('blockquote') }"
        >
          <svg-icon :iconClass="'quote'"></svg-icon>
        </button> -->
      </div>
    </bubble-menu>
    <editor-content
      class="editor-content"
      :class="{
        'editor-focus': isFocused,
        'tray-text': tray_text,
        'tray-image': tray_image,
      }"
      :editor="editor"
      ref="editor_content"
    />

    <div class="files dragArea" ref="fileList" v-show="files_show" v-viewer="v_viewer_option">
      <draggable
        v-bind="dragOptions"
        v-model="fileList"
        class="el-upload-list el-upload-list--picture-card"
        @start="dragImage"
        @end="drag = false"
        tag="ul"
      >
        <transition-group name="el-list">
          <template>
            <li
              class="el-upload-list__item"
              :class="['is-' + file.status + ' ' + file.type == 'image' ? '' : 'hide']"
              :key="file.uid"
              tabindex="0"
              v-for="file in fileList"
            >
              <el-image
                class="el-upload-list__item-thumbnail"
                :src="file.thumbnail_url ? file.thumbnail_url : blobToUrl(file)"
                :data-source="file.url ? file.url : blobToUrl(file)"
                v-if="!isOnLine"
              >
              </el-image>

              <el-image
                class="el-upload-list__item-thumbnail"
                :src="file.thumbnail_url ? file.thumbnail_url : blobToUrl(file)"
                v-if="file.status !== 'uploading' && file.type == 'image' && isOnLine"
                :data-source="file.url ? file.url : blobToUrl(file)"
              >
                <div slot="error" class="image-slot" v-if="!isOnLine">
                  <svg
                    width="68"
                    height="68"
                    viewBox="0 0 68 68"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    v-if="me.language != 'en'"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="67"
                      height="67"
                      rx="7.5"
                      fill="#EFEFEF"
                      stroke="#9D9D9D"
                      stroke-dasharray="2 2"
                    />
                    <path
                      d="M15.6377 44.4225H15.1017L15.4297 43.9105C15.1737 43.7585 14.9097 43.6145 14.6297 43.4785C14.8537 43.3185 15.0777 43.1425 15.3097 42.9345L14.7337 42.5825C14.4857 42.7905 14.2217 42.9825 13.9497 43.1585C13.5257 42.9665 13.0777 42.7905 12.6137 42.6305L12.2697 43.1425C12.5897 43.2545 12.9097 43.3825 13.2377 43.5265C12.8937 43.6705 12.5337 43.7905 12.1577 43.8865L12.4777 44.4225H11.9817V42.8225H11.1897V45.1105H13.0777L12.9577 45.4945H10.6937V48.6705H11.4937V46.2465H12.6777C12.5417 46.5585 12.3977 46.8305 12.2537 47.0625C12.2057 47.1265 12.1017 47.1665 11.9497 47.1825L12.1337 47.9265C13.4217 47.7825 14.3817 47.6625 15.0137 47.5505C15.0617 47.6545 15.1177 47.7665 15.1657 47.8785L15.8297 47.5505C15.5977 47.0865 15.3577 46.6545 15.1177 46.2465H16.1337V47.6945C16.1337 47.8465 16.0377 47.9265 15.8617 47.9265L15.3017 47.8945L15.5017 48.6705H16.1177C16.6617 48.6705 16.9337 48.3985 16.9337 47.8705V45.4945H13.7577C13.7977 45.3665 13.8377 45.2385 13.8857 45.1105H16.4297V42.8225H15.6377V44.4225ZM14.3017 46.2465C14.4297 46.4545 14.5577 46.6705 14.6857 46.9025C14.1577 46.9825 13.6137 47.0545 13.0537 47.1185C13.1977 46.8625 13.3337 46.5745 13.4697 46.2465H14.3017ZM13.9737 43.8705C14.3017 44.0305 14.6297 44.2145 14.9657 44.4225H12.6697C13.2057 44.2305 13.6377 44.0465 13.9737 43.8705ZM14.0537 41.1985L13.1977 41.3425C13.2777 41.4865 13.3577 41.6385 13.4377 41.7985H10.3417V42.5665H17.2697V41.7985H14.2937C14.2137 41.5825 14.1337 41.3825 14.0537 41.1985ZM20.9817 46.9105C20.1897 47.1985 19.2617 47.4225 18.2057 47.5985L18.3097 48.4145C19.3097 48.2305 20.1977 47.9905 20.9817 47.6945V46.9105ZM19.3897 41.2065C19.1257 42.0625 18.8137 42.8465 18.4537 43.5665C18.3497 43.7105 18.2377 43.8145 18.1097 43.8705L18.3097 44.6305L19.4457 44.4785C19.1017 45.0865 18.8137 45.5185 18.5897 45.7585C18.4857 45.8545 18.3577 45.9345 18.2137 45.9985L18.4297 46.7505C19.2057 46.6545 20.0297 46.4545 20.9017 46.1585V45.4145C20.3977 45.5905 19.9017 45.7265 19.4137 45.8305C19.8457 45.2545 20.3817 44.3665 21.0057 43.1585L20.2617 42.8705C20.1177 43.1745 19.9737 43.4545 19.8457 43.7265L19.0777 43.8225C19.4537 43.2305 19.8217 42.4625 20.1897 41.5265L19.3897 41.2065ZM24.8777 42.5905L23.0057 42.8545V41.2545H22.1657V42.9665L21.0297 43.1265L21.1497 43.8945L22.1817 43.7505C22.1977 44.0385 22.2137 44.3265 22.2457 44.5985L20.8937 44.8145L21.0137 45.5985L22.3577 45.3905C22.3817 45.5505 22.4137 45.7105 22.4537 45.8705C22.5417 46.2545 22.6537 46.6145 22.7977 46.9425C22.2377 47.3505 21.6057 47.6625 20.9017 47.8865L21.3897 48.5585C22.0217 48.3665 22.6217 48.0705 23.1817 47.6705C23.2137 47.7265 23.2617 47.7825 23.3097 47.8465C23.6697 48.3265 24.0537 48.5745 24.4697 48.5825C24.9337 48.5825 25.2777 48.0705 25.5177 47.0465L24.8057 46.5825C24.6937 47.3025 24.5497 47.6625 24.3737 47.6625C24.1977 47.6625 24.0057 47.4945 23.7897 47.1745C24.2297 46.7665 24.6457 46.2785 25.0377 45.7105L24.3737 45.2625C24.0937 45.6785 23.7817 46.0625 23.4377 46.3985C23.3417 46.1105 23.2617 45.7905 23.1977 45.4305C23.1817 45.3745 23.1737 45.3185 23.1737 45.2625L25.2217 44.9425L25.0937 44.1585L23.0777 44.4705C23.0457 44.2065 23.0297 43.9265 23.0217 43.6305L24.9977 43.3585L24.8777 42.5905ZM23.9017 41.2225L23.2697 41.6225C23.6297 41.9825 23.9177 42.3105 24.1257 42.6065L24.7817 42.1505C24.5737 41.8945 24.2777 41.5825 23.9017 41.2225ZM26.8137 41.5905V42.4065H29.0217V42.8705C29.0057 43.2945 28.9737 43.6945 28.9257 44.0785H26.3017V44.8865H28.7817C28.6777 45.3025 28.5497 45.6865 28.3897 46.0385C28.0057 46.7905 27.2697 47.4225 26.1657 47.9265L26.6377 48.6705C27.7417 48.2065 28.5417 47.5345 29.0377 46.6545C29.3017 46.1585 29.5017 45.5665 29.6457 44.8865H30.0777V47.5345C30.0777 48.1985 30.3897 48.5345 31.0137 48.5345H32.2857C32.6217 48.5345 32.8777 48.4545 33.0377 48.3025C33.2137 48.1425 33.3417 47.6305 33.4137 46.7665L32.6297 46.5025C32.5977 47.1105 32.5417 47.4705 32.4537 47.5825C32.3817 47.6945 32.2697 47.7585 32.1257 47.7585H31.2697C31.0297 47.7585 30.9097 47.6225 30.9097 47.3665V44.8865H33.3017V44.0785H29.7817C29.8297 43.7025 29.8537 43.3025 29.8697 42.8705V42.4065H32.6697V41.5905H26.8137ZM38.3337 41.2785V42.4625H36.5257V43.2705H38.3337V44.5105H36.1417V45.3265H37.8697C37.3257 46.6065 36.8777 47.3905 36.5417 47.6945C36.5017 47.7185 36.4457 47.7425 36.3657 47.7665L36.5497 48.4945C37.9417 48.3585 39.2297 48.1745 40.4217 47.9345C40.5177 48.1745 40.6217 48.4305 40.7257 48.7025L41.5177 48.3505C41.1657 47.4385 40.7577 46.5905 40.2937 45.7905L39.4857 46.0625C39.6937 46.4145 39.8937 46.7905 40.0937 47.2065C39.2697 47.3745 38.4377 47.5105 37.6057 47.6065C37.9417 47.1105 38.3337 46.3505 38.7657 45.3265H41.3577V44.5105H39.1817V43.2705H41.1497V42.4625H39.1817V41.2785H38.3337ZM34.9257 41.3265L34.3257 41.9025C34.8937 42.3345 35.3337 42.7345 35.6377 43.1105L36.2297 42.5105C35.8697 42.1185 35.4377 41.7265 34.9257 41.3265ZM34.7257 43.1985L34.1337 43.7745C34.6537 44.2145 35.0537 44.6225 35.3337 44.9905L35.9337 44.3985C35.5977 43.9985 35.1977 43.5985 34.7257 43.1985ZM35.4457 45.4625C35.1017 46.4065 34.6937 47.3345 34.2217 48.2305L35.0617 48.5985C35.4777 47.7185 35.8617 46.7745 36.2057 45.7745L35.4457 45.4625ZM43.3497 44.2145V47.2785H48.2937V44.2145H43.3497ZM47.4777 46.5425H44.1657V46.1105H47.4777V46.5425ZM44.1657 45.4065V44.9505H47.4777V45.4065H44.1657ZM42.5017 41.8945V42.6625H44.7017C44.1017 43.0945 43.2377 43.4545 42.1017 43.7585L42.5577 44.4945C43.8297 44.0225 44.7817 43.4305 45.4137 42.7185V43.9825H46.2297V42.7185C46.8297 43.4465 47.7977 44.0385 49.1337 44.4945L49.4937 43.7425C48.3897 43.4705 47.5497 43.1105 46.9577 42.6625H49.1417V41.8945H46.2297V41.2465H45.4137V41.8945H42.5017ZM42.3417 47.6945V48.4545H49.2777V47.6945H42.3417ZM50.7337 42.6465V43.3505H52.8537C52.7737 43.4625 52.6937 43.5825 52.6137 43.6945H50.3017V44.4305H52.0137C51.4857 44.9905 50.8457 45.5185 50.0937 46.0305L50.5417 46.7505C50.9257 46.4785 51.2937 46.1985 51.6457 45.9025V48.6785H52.4377V48.3825H55.8377V48.6785H56.6297V44.7665H52.7737C52.8617 44.6625 52.9497 44.5505 53.0457 44.4305H57.3737V43.6945H53.5417C53.6057 43.5825 53.6697 43.4625 53.7337 43.3505H56.9097V42.6465H54.0617C54.1097 42.5185 54.1577 42.3905 54.2057 42.2545C55.2217 42.1745 56.1097 42.0545 56.8777 41.8945L56.4937 41.2385C54.9337 41.5345 53.0297 41.6865 50.7817 41.6865L51.0057 42.3665C51.8537 42.3665 52.6537 42.3425 53.3977 42.3105L53.2457 42.6465H50.7337ZM52.4377 46.3985H55.8377V46.7265H52.4377V46.3985ZM55.8377 45.7745H52.4377V45.4385H55.8377V45.7745ZM52.4377 47.3505H55.8377V47.7105H52.4377V47.3505Z"
                      fill="#9D9D9D"
                    />
                    <g clip-path="url(#clip0_14725_3498)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M27.8704 21.8476C27.7765 22.088 27.7073 22.3374 27.664 22.5919C25.6288 23.0412 24.0916 24.8141 24.0916 26.9549C24.0916 29.4417 26.1656 31.4259 28.6828 31.4259H37.4487L36.2344 30.2116H28.6828C26.8006 30.2116 25.3058 28.7362 25.3058 26.9549C25.3058 25.2974 26.5978 23.9034 28.293 23.7176L28.8346 23.6569V23.1141C28.8346 23.023 28.8418 22.9295 28.8564 22.8336L27.8704 21.8476ZM30.9668 20.0869L30.0865 19.2065C31.1863 18.4674 32.4808 18.0715 33.8058 18.0687C37.0723 18.0687 39.7838 20.4973 40.0788 23.6289C42.012 23.9022 43.5201 25.5208 43.5201 27.5074C43.5181 28.1672 43.348 28.8157 43.0259 29.3917C42.7038 29.9676 42.2404 30.452 41.6793 30.7993L40.7892 29.9092C41.6963 29.4563 42.3058 28.5432 42.3058 27.5074C42.3058 26.0308 41.0673 24.8019 39.4972 24.8019H38.8901V24.1948C38.8913 21.4991 36.6327 19.283 33.8058 19.283C32.7433 19.283 31.7683 19.5987 30.9656 20.0857L30.9668 20.0869ZM40.6617 33.07L26.0903 18.4986L26.95 17.6389L41.5214 32.2103L40.6629 33.0688L40.6617 33.07Z"
                        fill="#979797"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14725_3498">
                        <rect x="24.0916" y="15.64" width="19.4286" height="19.4286" rx="8" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                    <rect
                      x="0.5"
                      y="0.5"
                      width="67"
                      height="67"
                      rx="7.5"
                      fill="#EFEFEF"
                      stroke="#9D9D9D"
                      stroke-dasharray="2 2"
                    />
                    <path
                      d="M24.1465 45.144C22.8292 45.144 22.1705 44.4107 22.1705 42.944V41.68C22.1705 40.2133 22.8398 39.48 24.1785 39.48C24.7918 39.48 25.2772 39.6533 25.6345 40C25.9918 40.3413 26.1705 40.9013 26.1705 41.68V42.944C26.1705 43.7227 25.9865 44.2853 25.6185 44.632C25.2558 44.9733 24.7652 45.144 24.1465 45.144ZM24.1785 44.208C24.4985 44.208 24.7358 44.1067 24.8905 43.904C25.0452 43.696 25.1225 43.3707 25.1225 42.928V41.736C25.1225 41.2667 25.0452 40.928 24.8905 40.72C24.7358 40.5067 24.4985 40.4 24.1785 40.4C23.8425 40.4 23.5998 40.504 23.4505 40.712C23.3012 40.9147 23.2265 41.256 23.2265 41.736V42.928C23.2265 43.3813 23.3012 43.7093 23.4505 43.912C23.5998 44.1093 23.8425 44.208 24.1785 44.208ZM28.5782 40.232C28.4342 40.232 28.3275 40.2667 28.2582 40.336C28.1942 40.4 28.1622 40.4987 28.1622 40.632V40.92H28.9062V41.616H28.1622V45.08H27.1782V41.616H26.7382V40.92H27.1782V40.672C27.1782 40.32 27.2769 40.048 27.4742 39.856C27.6769 39.6587 27.9622 39.56 28.3302 39.56H28.9062V40.232H28.5782ZM31.2501 40.232C31.1061 40.232 30.9994 40.2667 30.9301 40.336C30.8661 40.4 30.8341 40.4987 30.8341 40.632V40.92H31.5781V41.616H30.8341V45.08H29.8501V41.616H29.4101V40.92H29.8501V40.672C29.8501 40.32 29.9487 40.048 30.1461 39.856C30.3487 39.6587 30.6341 39.56 31.0021 39.56H31.5781V40.232H31.2501ZM33.4901 45.08C33.0901 45.08 32.7781 44.9707 32.5541 44.752C32.3354 44.5333 32.2261 44.2213 32.2261 43.816V39.56H33.2181V43.752C33.2181 43.9227 33.2474 44.0453 33.3061 44.12C33.3701 44.1893 33.4714 44.224 33.6101 44.224H33.9461V45.08H33.4901ZM34.5628 40.92H35.5468V45.08H34.5628V40.92ZM34.5468 39.56H35.5548V40.352H34.5468V39.56ZM36.4525 40.92H37.4205V41.296C37.5432 41.1573 37.6898 41.0533 37.8605 40.984C38.0365 40.9093 38.2178 40.872 38.4045 40.872C38.8312 40.872 39.1618 41.0053 39.3965 41.272C39.6312 41.5387 39.7485 41.904 39.7485 42.368V45.08H38.7565V42.488C38.7565 42.2533 38.6978 42.072 38.5805 41.944C38.4632 41.816 38.3058 41.752 38.1085 41.752C37.9165 41.752 37.7565 41.816 37.6285 41.944C37.5058 42.072 37.4445 42.2533 37.4445 42.488V45.08H36.4525V40.92ZM41.5208 43.296V43.408C41.5208 43.7173 41.5901 43.9387 41.7288 44.072C41.8674 44.2053 42.0648 44.272 42.3208 44.272C42.5181 44.272 42.6728 44.232 42.7848 44.152C42.8968 44.0667 42.9581 43.9493 42.9688 43.8L42.9768 43.776H43.9208V43.816C43.9208 44.2107 43.7741 44.528 43.4808 44.768C43.1874 45.008 42.7874 45.128 42.2808 45.128C41.7474 45.128 41.3234 44.976 41.0088 44.672C40.6941 44.3627 40.5368 43.888 40.5368 43.248V42.744C40.5368 42.12 40.6888 41.6533 40.9928 41.344C41.2968 41.0293 41.7154 40.872 42.2488 40.872C42.7714 40.872 43.1848 41.0293 43.4888 41.344C43.7981 41.6587 43.9528 42.1253 43.9528 42.744V43.296H41.5208ZM42.2488 41.72C42.0141 41.72 41.8328 41.7867 41.7048 41.92C41.5821 42.0533 41.5208 42.2773 41.5208 42.592V42.616H42.9608V42.512C42.9608 41.984 42.7234 41.72 42.2488 41.72ZM18.1662 54.128C17.6435 54.128 17.2302 53.9867 16.9262 53.704C16.6275 53.4213 16.4782 52.9813 16.4782 52.384V51.608C16.4782 51.016 16.6275 50.5787 16.9262 50.296C17.2302 50.0133 17.6435 49.872 18.1662 49.872C18.6782 49.872 19.0782 50.0027 19.3662 50.264C19.6542 50.5253 19.7982 50.888 19.7982 51.352V51.432H18.8542V51.384C18.8542 51.1867 18.7928 51.032 18.6702 50.92C18.5528 50.808 18.3902 50.752 18.1822 50.752C17.7022 50.752 17.4622 51.0427 17.4622 51.624V52.376C17.4622 52.6907 17.5235 52.9147 17.6462 53.048C17.7742 53.1813 17.9528 53.248 18.1822 53.248C18.3902 53.248 18.5528 53.1947 18.6702 53.088C18.7928 52.9813 18.8542 52.832 18.8542 52.64V52.592H19.7982V52.648C19.7982 53.1067 19.6542 53.4693 19.3662 53.736C19.0782 53.9973 18.6782 54.128 18.1662 54.128ZM22.0932 49.872C22.6212 49.872 23.0266 49.9973 23.3092 50.248C23.5919 50.4933 23.7332 50.8587 23.7332 51.344V54.08H22.7732V53.72C22.6346 53.864 22.4906 53.968 22.3412 54.032C22.1972 54.096 22.0132 54.128 21.7892 54.128C21.3626 54.128 21.0319 54.0133 20.7972 53.784C20.5626 53.5547 20.4452 53.2373 20.4452 52.832C20.4452 52.4587 20.5706 52.1653 20.8212 51.952C21.0719 51.7333 21.4212 51.624 21.8692 51.624H22.7492V51.296C22.7492 50.8533 22.5279 50.632 22.0852 50.632C21.8986 50.632 21.7492 50.68 21.6372 50.776C21.5306 50.8667 21.4772 50.9893 21.4772 51.144V51.168H20.5572V51.136C20.5572 50.7467 20.6959 50.44 20.9732 50.216C21.2506 49.9867 21.6239 49.872 22.0932 49.872ZM22.0132 53.328C22.2746 53.328 22.4612 53.2693 22.5732 53.152C22.6906 53.0293 22.7492 52.8453 22.7492 52.6V52.304H22.0292C21.6132 52.304 21.4052 52.472 21.4052 52.808C21.4052 53.1547 21.6079 53.328 22.0132 53.328ZM24.597 49.92H25.565V50.296C25.6877 50.1573 25.8344 50.0533 26.005 49.984C26.181 49.9093 26.3624 49.872 26.549 49.872C26.9757 49.872 27.3064 50.0053 27.541 50.272C27.7757 50.5387 27.893 50.904 27.893 51.368V54.08H26.901V51.488C26.901 51.2533 26.8424 51.072 26.725 50.944C26.6077 50.816 26.4504 50.752 26.253 50.752C26.061 50.752 25.901 50.816 25.773 50.944C25.6504 51.072 25.589 51.2533 25.589 51.488V54.08H24.597V49.92ZM28.5472 48.56H29.4832V50.16L28.5472 50.952V48.56ZM31.55 50.616V52.816C31.55 53.0987 31.686 53.24 31.958 53.24H32.27V54.08H31.798C31.4194 54.08 31.118 53.9733 30.894 53.76C30.6754 53.5413 30.566 53.248 30.566 52.88V50.616H29.99V49.92H30.566V49.104L31.55 48.76V49.92H32.35V50.616H31.55ZM34.3464 49.92H35.3944L36.2024 52.56L37.0024 49.92H38.0504L36.6024 54.08H35.7864L34.3464 49.92ZM38.598 49.92H39.582V54.08H38.598V49.92ZM38.582 48.56H39.59V49.352H38.582V48.56ZM41.3997 52.296V52.408C41.3997 52.7173 41.469 52.9387 41.6077 53.072C41.7463 53.2053 41.9437 53.272 42.1997 53.272C42.397 53.272 42.5517 53.232 42.6637 53.152C42.7757 53.0667 42.837 52.9493 42.8477 52.8L42.8557 52.776H43.7997V52.816C43.7997 53.2107 43.653 53.528 43.3597 53.768C43.0663 54.008 42.6663 54.128 42.1597 54.128C41.6263 54.128 41.2023 53.976 40.8877 53.672C40.573 53.3627 40.4157 52.888 40.4157 52.248V51.744C40.4157 51.12 40.5677 50.6533 40.8717 50.344C41.1757 50.0293 41.5943 49.872 42.1277 49.872C42.6503 49.872 43.0637 50.0293 43.3677 50.344C43.677 50.6587 43.8317 51.1253 43.8317 51.744V52.296H41.3997ZM42.1277 50.72C41.893 50.72 41.7117 50.7867 41.5837 50.92C41.461 51.0533 41.3997 51.2773 41.3997 51.592V51.616H42.8397V51.512C42.8397 50.984 42.6023 50.72 42.1277 50.72ZM44.1433 49.92H45.1913L45.8393 52.56L46.6393 49.92H47.3833L48.1833 52.56L48.8313 49.92H49.8873L48.6633 54.08H47.8233L47.0073 51.384L46.1993 54.08H45.3593L44.1433 49.92Z"
                      fill="#9D9D9D"
                    />
                    <g clip-path="url(#clip0_14725_3499)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M28.2588 21.8476C28.1649 22.088 28.0957 22.3375 28.0524 22.5919C26.0173 23.0412 24.48 24.8141 24.48 26.9549C24.48 29.4417 26.554 31.4259 29.0712 31.4259H37.8371L36.6228 30.2116H29.0712C27.1891 30.2116 25.6943 28.7362 25.6943 26.9549C25.6943 25.2974 26.9863 23.9034 28.6814 23.7176L29.223 23.6569V23.1141C29.223 23.023 29.2303 22.9295 29.2448 22.8336L28.2588 21.8476ZM31.3553 20.0869L30.4749 19.2065C31.5747 18.4674 32.8692 18.0715 34.1943 18.0687C37.4607 18.0687 40.1722 20.4973 40.4673 23.6289C42.4004 23.9022 43.9086 25.5208 43.9086 27.5074C43.9065 28.1673 43.7364 28.8157 43.4143 29.3917C43.0922 29.9676 42.6288 30.452 42.0677 30.7993L41.1776 29.9092C42.0847 29.4563 42.6943 28.5432 42.6943 27.5074C42.6943 26.0308 41.4557 24.8019 39.8856 24.8019H39.2785V24.1948C39.2797 21.4991 37.0211 19.283 34.1943 19.283C33.1318 19.283 32.1567 19.5987 31.3541 20.0857L31.3553 20.0869ZM41.0501 33.07L26.4787 18.4986L27.3384 17.6389L41.9098 32.2103L41.0513 33.0688L41.0501 33.07Z"
                        fill="#979797"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14725_3499">
                        <rect x="24.48" y="15.64" width="19.4286" height="19.4286" rx="8" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </el-image>

              <el-progress
                v-if="file.status === 'uploading' && isOnLine"
                type="circle"
                stroke-width="6"
                :percentage="parseInt(file.progress)"
                width="50"
              >
              </el-progress>
              <label
                style="position: absolute; right: 5px; cursor: pointer; top: 0px"
                v-baidu-event-tracking="{
                  feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
                  action: '图片删除',
                }"
                @click="handleRemoveFile(file)"
                @touchstart.stop.prevent="handleRemoveFile(file)"
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle opacity="0.5" cx="6" cy="6" r="6" fill="black" />
                  <path
                    d="M8.33697 3.33022C8.40328 3.33024 8.46808 3.35003 8.52308 3.38707C8.57808 3.42411 8.62079 3.47671 8.64574 3.53815C8.6707 3.59958 8.67676 3.66707 8.66316 3.73197C8.64956 3.79687 8.61691 3.85624 8.56939 3.90249L6.47173 6.00014L8.56939 8.0978C8.60138 8.12852 8.62692 8.16531 8.64452 8.20602C8.66211 8.24672 8.67141 8.29054 8.67186 8.33488C8.67231 8.37923 8.66391 8.42322 8.64714 8.46428C8.63038 8.50534 8.60559 8.54264 8.57423 8.574C8.54287 8.60536 8.50557 8.63015 8.46451 8.64691C8.42345 8.66367 8.37946 8.67207 8.33512 8.67162C8.29077 8.67117 8.24696 8.66188 8.20625 8.64428C8.16554 8.62669 8.12875 8.60115 8.09804 8.56916L6.00038 6.4715L3.90272 8.56916C3.87201 8.60115 3.83522 8.62669 3.79451 8.64428C3.7538 8.66188 3.70999 8.67117 3.66564 8.67163C3.62129 8.67208 3.5773 8.66367 3.53624 8.64691C3.49518 8.63015 3.45788 8.60536 3.42652 8.574C3.39516 8.54264 3.37038 8.50534 3.35361 8.46428C3.33685 8.42322 3.32845 8.37923 3.3289 8.33488C3.32935 8.29054 3.33864 8.24672 3.35624 8.20602C3.37384 8.16531 3.39938 8.12852 3.43137 8.0978L5.52903 6.00014L3.43137 3.90249C3.3832 3.85567 3.3503 3.79539 3.33698 3.72955C3.32366 3.66371 3.33054 3.59538 3.35672 3.53352C3.3829 3.47166 3.42716 3.41915 3.4837 3.38287C3.54023 3.34659 3.60641 3.32824 3.67356 3.33022C3.76016 3.3328 3.84235 3.369 3.90272 3.43113L6.00038 5.52879L8.09804 3.43113C8.1291 3.3992 8.16625 3.37382 8.20728 3.35649C8.24832 3.33916 8.29242 3.33023 8.33697 3.33022Z"
                    fill="white"
                  />
                </svg>
              </label>
              <!-- <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>

                <span class="el-upload-list__item-delete" @click="handleRemoveFile(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span> -->
            </li>
          </template>
          <li key="upload" class="el-upload-list__item uploadBtn">
            <el-upload
              ref="upload"
              action="/api/file/upload"
              name="files"
              :headers="{ 'X-CSRF-TOKEN': csrf_token }"
              list-type="picture-card"
              :file-list="initFiles"
              :before-upload="handleBeforeFileUpload"
              :http-request="handleFileUpload"
              :on-success="handleFileUploadSuccess"
              :on-preview="handlePictureCardPreview"
              :before-remove="beforeFileRemove"
              :on-progress="handleFileUploadProgress"
              :show-file-list="false"
              :multiple="true"
              :limit="9"
              :on-exceed="onExceedFileLimit"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </li>
        </transition-group>
      </draggable>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </div>
    <AudioPlayerVue
      v-for="file in audioFileList"
      :key="file.id"
      :src="file.url"
      :isEdit="true"
      :delFun="() => handleRemoveFile(file)"
    />
    <div class="editor-menu-bar" v-if="editor">
      <div class="pin-left toolMenu" v-if="showToolButtons">
        <el-button
          type="text"
          @click.stop="insertTagText"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '标签',
          }"
        >
          <svg-icon :iconClass="'hashTag'" className="hashTag"></svg-icon>
        </el-button>
        <el-button
          type="text"
          @click="uploadFile"
          @touchstart.stop.prevent="uploadFile"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '上传图片',
          }"
        >
          <svg-icon :iconClass="'photo'"></svg-icon>
        </el-button>
        <span class="vertical-line"></span>

        <el-popover
          @show="handleShowPopoverMenu"
          @hide="handleHidePopoverMenu"
          placement="top"
          width="122"
          trigger="click"
          popper-class="toolMenuPopover"
        >
          <div class="toolMenu floatMenu">
            <span
              @click.stop="editor.chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold') }"
              v-baidu-event-tracking="{
                feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
                action: '弹出菜单-加粗',
              }"
            >
              <svg-icon :iconClass="'bold'"></svg-icon>
            </span>
            <span
              @click.stop="editor.chain().focus().toggleUnderline().run()"
              :class="{ 'is-active': editor.isActive('underline') }"
              v-baidu-event-tracking="{
                feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
                action: '弹出菜单-下划线',
              }"
            >
              <svg-icon :iconClass="'underline'"></svg-icon>
            </span>

            <!-- <span
              @click.stop="editor.chain().focus().toggleStrike().run()"
              :class="{ 'is-active': editor.isActive('strike') }"
            >
              <svg-icon :iconClass="'strike'"></svg-icon>
            </span> -->
            <span
              @click.stop="editor.chain().focus().toggleHighlight().run()"
              :class="{ 'is-active': editor.isActive('highlight') }"
              v-baidu-event-tracking="{
                feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
                action: '弹出菜单-高亮',
              }"
            >
              <svg-icon :iconClass="'mark'"></svg-icon>
            </span>
          </div>
          <el-button
            slot="reference"
            class="toolMenuFont"
            style="margin-right: 3px; height: 30px; margin-top: 2px"
            :class="{
              'is-active': showPopoverMenu,
            }"
            type="text"
            v-baidu-event-tracking="{
              feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
              action: 'Aa',
            }"
          >
            <svg-icon :iconClass="'font'"></svg-icon
          ></el-button>
        </el-popover>
        <el-button
          type="text"
          :class="{ 'is-active': editor.isActive('bulletList') }"
          @click.stop="editor.chain().focus().toggleBulletList().run()"
          @touchstart.stop.prevent="editor.chain().focus().toggleBulletList().run()"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '无序列表',
          }"
        >
          <svg-icon :iconClass="'ul'"></svg-icon>
        </el-button>
        <el-button
          type="text"
          :class="{ 'is-active': editor.isActive('orderedList') }"
          @click.stop="editor.chain().focus().toggleOrderedList().run()"
          @touchstart.stop.prevent="editor.chain().focus().toggleOrderedList().run()"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '有序列表',
          }"
        >
          <svg-icon :iconClass="'ol'"></svg-icon>
        </el-button>
        <!-- <el-button
          type="text"
          :class="{ 'is-active': editor.isActive('blockquote') }"
          @click.stop="editor.chain().focus().toggleBlockquote().run()"
        >
          <svg-icon :iconClass="'quote'"></svg-icon>
        </el-button> -->
        <span class="vertical-line"></span>
        <el-button
          type="text"
          @click="addRelation"
          @touchstart.stop.prevent="addRelation"
          style="margin-right: 3px; margin-left: 0px"
          v-baidu-event-tracking="{
            feature: isTray ? '快捷窗口新建' : memo_slug ? '编辑Memo' : '新建Memo',
            action: '@',
          }"
        >
          <svg-icon :iconClass="'quoteLink'"></svg-icon>
        </el-button>

        <el-button
          type="text"
          @click="editor.chain().focus().setHardBreak().run()"
          @touchstart.stop.prevent="editor.chain().focus().setHardBreak().run()"
          id="newLine"
        >
        </el-button>
      </div>
      <div class="pin-right">
        <el-button
          class="cancel-btn"
          size="small"
          @click="onCancel"
          @touchstart.stop.prevent="onCancel"
          v-if="initContent || (initFiles.length && !isTray)"
          v-baidu-event-tracking="{
            feature: '编辑Memo',
            action: '取消编辑',
          }"
          >{{ $t('fleditor.cancel') }}</el-button
        >

        <svg
          width="44"
          height="28"
          viewBox="0 0 44 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-show="!submitable && !isTray"
          class="disableSave"
        >
          <rect width="44" height="27.0769" rx="6" fill="currentColor" />
          <path
            d="M16.0838 19.4615L30.4615 13.1154L16.0838 6.76923L16.0769 11.7051L26.3517 13.1154L16.0769 14.5256L16.0838 19.4615Z"
            fill="currentColor"
          />
        </svg>
        <el-tooltip
          placement="top"
          :visible-arrow="false"
          :transition="''"
          :disabled="!submitable"
          v-model="tooltipVisible"
        >
          <div slot="content" style="font-size: 12px; border-radius: 6px">
            <p>{{ $t('fleditor.saveTips') }}</p>
            <p style="color: #9d9d9d; margin-top: 6px">{{ traySaveKey }}</p>
          </div>
          <span v-if="isTray" style="width: 44px; height: 28px; display: inline-block; margin-right: 18px">
            <svg
              width="44"
              height="28"
              viewBox="0 0 44 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              v-if="!submitable"
              class="disableSave"
              @mouseenter="tooltipVisible = true"
              @mouseleave="tooltipVisible = false"
            >
              <rect width="44" height="27.0769" rx="6" fill="currentColor" />
              <path
                d="M16.0838 19.4615L30.4615 13.1154L16.0838 6.76923L16.0769 11.7051L26.3517 13.1154L16.0769 14.5256L16.0838 19.4615Z"
                fill="currentColor"
              />
            </svg>
            <svg
              width="44"
              height="28"
              viewBox="0 0 44 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="cursor: pointer"
              class="saveBtn"
              @click="onSubmit"
              @touchstart.stop.prevent="onSubmit"
              v-else
            >
              <rect width="44" height="27.0769" rx="6" fill="#55BB8E" />
              <path
                d="M16.0838 19.4615L30.4615 13.1154L16.0838 6.76923L16.0769 11.7051L26.3516 13.1154L16.0769 14.5256L16.0838 19.4615Z"
                fill="white"
              />
            </svg>
          </span>
        </el-tooltip>
        <el-tooltip v-model="hideSaveTip" placement="bottom" :visible-arrow="false" :transition="''">
          <div slot="content" style="font-size: 12px; border-radius: 6px">
            <p>{{ $t('fleditor.saveTips') }}</p>
            <p style="color: #9d9d9d; margin-top: 6px">{{ saveHotKey }}</p>
          </div>
          <svg
            width="44"
            height="28"
            viewBox="0 0 44 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="cursor: pointer"
            class="saveBtn"
            v-show="submitable && !isTray && !is_mobile"
            @click="onSubmit"
            @mouseenter="hideSaveTip = true"
            @mouseleave="hideSaveTip = false"
          >
            <rect width="44" height="27.0769" rx="6" fill="currentColor" />
            <path
              d="M16.0838 19.4615L30.4615 13.1154L16.0838 6.76923L16.0769 11.7051L26.3516 13.1154L16.0769 14.5256L16.0838 19.4615Z"
              fill="currentColor"
            />
          </svg>
        </el-tooltip>

        <svg
          width="44"
          height="28"
          viewBox="0 0 44 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="cursor: pointer"
          class="saveBtn"
          v-show="submitable && !isTray && is_mobile"
          @click="onSubmit"
          @touchstart.stop.prevent="onSubmit"
        >
          <rect width="44" height="27.0769" rx="6" fill="currentColor" />
          <path
            d="M16.0838 19.4615L30.4615 13.1154L16.0838 6.76923L16.0769 11.7051L26.3516 13.1154L16.0769 14.5256L16.0838 19.4615Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'

import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2'
import History from '@tiptap/extension-history'
import Mention from '@tiptap/extension-mention'
import Placeholder from '@tiptap/extension-placeholder'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Highlight from '@tiptap/extension-highlight'
import Text from '@tiptap/extension-text'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Underline from '@tiptap/extension-underline'
import Bold from '@tiptap/extension-bold'
import DBUtil from '../utils/DBUtil'
import DateUtil from '../utils/DateUtil'
import AudioPlayerVue from '../components/AudioPlayer.vue'
import { Relation } from '../components/tiptap/relation/relation'
import relation from '../components/tiptap/relation'
import suggestion from '../components/tiptap/suggestion'
import { getOsType } from '../utils/utils'
import logClickEvent from '../utils/logClickEvent'

export default {
  components: {
    EditorContent,
    draggable,
    AudioPlayerVue,
    BubbleMenu,
  },
  props: {
    memo_slug: {
      type: String,
      default: null,
    },
    draftKey: {
      type: String,
      default: null,
    },
    initContent: {
      type: String,
      default: null,
    },
    initFiles: {
      type: Array,
      default: function () {
        return []
      },
    },
    apiEndPoint: {
      type: String,
      default: '/api/memo/',
    },
    title: {
      type: String,
      default: null,
    },
    showToolButtons: {
      type: Boolean,
      default: true,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '现在的想法是...',
    },
    onFocus: {
      type: Function,
      default: function () {},
    },
    onBlur: {
      type: Function,
      default: function () {},
    },
    show_all: {
      type: Boolean,
      default: false,
    },
    isTray: {
      type: Boolean,
      default: false,
    },
    http_direct: {
      type: Boolean,
      default: false,
    },
    calMemosHeight: {
      type: Function,
      default: function () {},
    },
    traySaveKey: {
      type: String,
      default: '',
    },
    onUpdate: {
      type: Function,
      default: function () {},
    },
    is_review: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640, // is_mobile || document.body.clientWidth <= 640, // 为了编译通过，暂时去掉实际的移动端判断，后续再加上
      me: this.$store.state.me,
      loading: false,
      editor: null,
      files_show: false,
      csrf_token: '', // csrf_token, // 先注释，应该不需要用到了？
      file_ids: [],
      local_files: [], //无网时,本地图片指向这个
      dialogImageUrl: '',
      dialogVisible: false,
      hashtag: {
        popup: null,
        query: null,
        suggestionRange: null,
        navigatedIndex: 0,
        insertMention: () => {},
      },
      lastVirtualNode: null,
      theme: this.$store.state.theme,
      isFocused: false,
      fileList: [],
      drag: false,
      pasteImages: [],
      isElectron: this.$store.getters.isElectron,
      hideSaveTip: false,
      v_viewer_option: {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
      },
      showPopoverMenu: false,
      tooltipVisible: false,
    }
  },
  computed: {
    tray_image() {
      return this.isTray && this.fileList.length
    },
    tray_text() {
      return this.isTray && !this.fileList.length
    },
    undoClass() {
      return !this.editor || !this.editor.can().undo() ? 'is-disabled' : ''
    },
    redoClass() {
      return !this.editor || !this.editor.can().redo() ? 'is-disabled' : ''
    },
    isOnLine() {
      return this.$store.state.isOnLine
    },
    filteredTags() {
      if (this.hashtag.query === null) return []
      if (!this.hashtag.query) return this.$store.state.latest_tag_names

      let _filteredTags = []
      for (const index in this.$store.state.tags) {
        const tag = this.$store.state.tags[index].name
        if (tag.toUpperCase().indexOf(this.hashtag.query.toUpperCase()) != -1) {
          _filteredTags.push(tag)
        }
      }
      return _filteredTags
    },
    open_hashtag_auto_complete() {
      if (this.me.id > 2 && this.is_mobile) return false
      return true
    },
    needCompress() {
      if (!this.$store.getters.is_pro) return true
      let user_settings = this.$store.state.user_settings
      for (let i = 0; i < user_settings.length; i++) {
        if (user_settings[i].type !== 1002) continue
        return parseInt(user_settings[i].value) != 1
      }
      return false
    },
    submitable() {
      if (this.title) return true // 编辑标签描述时，允许空内容
      // 这段代码重复了
      let content = this.editor.getHTML()
      content = content.replace(/<p><\/p>$/g, '') // 去掉最后的空 p 标签
      // 去掉所有html tag
      content = content.replace(/<[^>]*>/g, '')
      return content || this.fileList.length || this.file_ids.length
    },
    isDark() {
      return document.body.classList.contains('dark_mode')
    },
    dragOptions() {
      return {
        animation: 300,
        group: 'description',
        disabled: this.$isMobile() || document.body.clientWidth <= 640 ? true : false,
        ghostClass: 'ghost',
      }
    },
    imageFileList() {
      return this.fileList.filter((file) => {
        return file.type == 'image'
      })
    },
    audioFileList() {
      return this.fileList.filter((file) => {
        return file.type == 'audio'
      })
    },
    saveHotKey() {
      let key = this.$store.state.hotkeys.filter((item) => item.action == 'save')[0].key
      let osType = getOsType()

      // 兼容之前的设置
      if (typeof key == 'string') {
        if (osType == 'mac') {
          if (key.indexOf('Shift') > -1) {
            key = key.replace('Shift+', '⇧ + ')
          }
          if (key.indexOf('Meta') > -1) {
            key = key.replace('Meta+', '⌘ + ')
          }
        } else {
          key = key.replace('Meta+', 'Ctrl + ')
        }
      } else {
        key = key.map((item) => {
          let keyStr = item

          if (osType == 'win') {
            keyStr = keyStr.replace('Meta+', 'Ctrl + ')
          } else {
            if (keyStr.indexOf('Shift') > -1) {
              keyStr = keyStr.replace('Shift+', '⇧ + ')
            }
            if (keyStr.indexOf('Meta') > -1) {
              keyStr = keyStr.replace('Meta+', '⌘ + ')
            }
          }
          return keyStr
        })

        key = key.join(' / ')
      }

      return key
    },
    newLineKey() {
      return this.$store.state.hotkeys.filter((item) => item.action == 'newBlank')[0].key
    },
    is_new_user() {
      return this.$store.getters.is_new_user
    },
  },
  methods: {
    // 显示 memo 引导
    showMemoGuide() {
      if (!this.memo_slug && this.is_new_user) {
        this.$store.dispatch('onboarding/setMemoHelpTip', '0')
      }
    },
    dragImage() {
      this.drag = true
      logClickEvent(this.isTray ? '快捷窗口新建' : this.memo_slug ? '编辑Memo' : '新建Memo', '图片拖拽')
    },
    handleShowPopoverMenu() {
      this.showPopoverMenu = true
    },
    handleHidePopoverMenu() {
      this.showPopoverMenu = false
    },
    handleFileUploadProgress(event, file, fileList) {
      this.fileList.forEach((element, index) => {
        if (element.uid === file.uid) {
          // 更新这个uid下的进度
          const progress = Math.floor(event.percent)
          // 防止上传完接口还没有返回成功值，所以此处给定progress的最大值为99，成功的钩子中再置为100
          element.progress = progress === 100 ? 99 : progress
          this.$set(this.fileList, index, element)
        }
      })
    },
    // 使editor 失去焦点
    blur() {
      this.editor.commands.blur()
    },

    // 内容是否超过 60000 字符
    isOverLimit() {
      let content = this.editor.getHTML()
      content = content.replace(/<p><\/p>$/g, '') // 去掉最后的空 p 标签
      // 去掉所有html tag
      content = content.replace(/<[^>]*>/g, '')
      return content.length > 60000
    },
    async onSubmit() {
      // 这段代码重复了
      this.blur()
      let content = this.editor.getHTML()
      content = content.replace(/<p><\/p>$/g, '') // 去掉最后的空 p 标签
      content = content.replace('＃', '#') // # 全角转半角
      content = content.replace(/<span data-type="mention" class="mention" data-id="[^"]*">([^<]*)<\/span>/g, '$1') // 去掉 mention 的 span
      // 替换nbsp
      content = content.replace(/&nbsp;/g, ' ')
      // 将空格转换为 \u00a0，但标签内的空格不做转换
      // let spaceRex1 = /(<.*?>)(.*?)(<\/.*?>)/g
      // let spaceRex2 = /\s/g
      // content = content.replace(spaceRex1, function(str, $1, $2, $3) {return [$1,$2.replace(spaceRex2,'\u00a0'), $3].join('')})
      if (this.isOverLimit()) {
        this.$message.error(this.$t('fleditor.message.over_limit'))
        return
      }
      if (!this.submitable) {
        this.$message.error(this.$t('fleditor.message.empty_content'))
        this.editor.commands.clearContent()
        this.editor.chain().focus().run()
        return
      }
      this.loading = true
      const last_sync_time = await DBUtil.getLastSyncTime()
      this.showMemoGuide()
      // 还没初始化
      if (last_sync_time == 0) {
        let url = '/memo'
        if (this.memo_slug) {
          url = '/memo/' + this.memo_slug
        }
        this.$api.call(
          'PUT',
          url,
          {
            content: content,
            created_at: DateUtil.today(),
            source: 'web',
            file_ids: this.fileList.map((file) => file.id),
            tz: DateUtil.getTz(),
          },
          (response) => {
            if (response.data && response.data.code === 0) {
              this.loading = false
              this.editor.commands.setContent('')
              this.file_ids = []
              this.$refs.upload.clearFiles()
              this.files_show = false
              this.local_files = []
              this.fileList = []
              this.pasteImages = []
              this.$emit('memo-updated', response.data.data)

              this.isFocused = false
            } else {
              this.loading = false
            }

            if (this.draftKey) {
              localStorage.removeItem(this.draftKey)
            }

            this.$store.commit('setEditMemoSlug', '')
          },
        )
        if (!this.memo_slug) {
          this.focus()
        }

        return
      }

      if (this.isTray) {
        logClickEvent('快捷窗口新建', '发布')
        let memo = null
        if (this.$store.state.isOnLine) {
          memo = {
            content: content,
            source: 'web',
            file_ids: this.fileList.map((file) => file.id),
          }
        } else {
          //如果没有网,把图片本地地址丢进去
          //目前似乎不支持拖曳排序,则新增的local_files总是放在原本的file_ids后面
          //TODO 后续还是要支持指定顺序

          let files = []
          for (let file of this.fileList) {
            if (!file.url) {
              files.push({ id: 0, file: file })
            } else {
              files.push(file)
            }
          }

          if (this.local_files && this.local_files.length) {
            for (let file of this.local_files) {
              files.push({ id: 0, file: file })
            }
          }

          memo = {
            content: content,
            source: 'web',
            // file_ids:  vm.file_ids, //[3983640]
            files: files,
          }
        }
        this.editor.commands.setContent('')
        const newMemo = {
          ...memo,
          files: this.fileList,
        }
        window.ipcRenderer.send('newMemoCreated', JSON.stringify(newMemo))
        this.$emit('memo-updated', newMemo)
        this.loading = false
        this.file_ids = []
        this.$refs.upload.clearFiles()
        this.files_show = false
        this.local_files = []
        this.fileList = []
        this.pasteImages = []

        if (this.draftKey) {
          localStorage.removeItem(this.draftKey)
        }

        return
      }

      logClickEvent(this.memo_slug ? '编辑Memo' : '新建MEMO', '发布')
      let vm = this
      let query
      if (!vm.memo_slug) {
        if (this.$store.state.isOnLine) {
          query = DBUtil.addMemo({
            content: content,
            source: vm.is_mobile ? 'mobile' : 'web',
            file_ids: vm.fileList.map((file) => file.id),
          })
        } else {
          //如果没有网,把图片本地地址丢进去
          //目前似乎不支持拖曳排序,则新增的local_files总是放在原本的file_ids后面
          //TODO 后续还是要支持指定顺序

          let files = []
          for (let file of this.fileList) {
            if (!file.url) {
              files.push({ id: 0, file: file })
            } else {
              files.push(file)
            }
          }

          if (this.local_files && this.local_files.length) {
            for (let file of this.local_files) {
              files.push({ id: 0, file: file })
            }
          }

          query = DBUtil.addMemo({
            content: content,
            source: vm.is_mobile ? 'mobile' : 'web',
            // file_ids:  vm.file_ids, //[3983640]
            files: files,
          })
        }
      } else {
        if (this.$store.state.isOnLine) {
          if (this.http_direct) {
            query = DBUtil.editMemoDirect(
              vm.memo_slug,
              content,
              vm.is_mobile ? 'mobile' : 'web',
              vm.fileList.map((file) => file.id),
            )
          } else {
            query = DBUtil.editMemo({
              slug: vm.memo_slug,
              content: content,
              source: vm.is_mobile ? 'mobile' : 'web',
              file_ids: vm.fileList.map((file) => file.id),
            })
          }
        } else {
          //如果没有网,把图片本地地址丢进去
          //目前似乎不支持拖曳排序,则新增的local_files总是放在原本的file_ids后面
          //TODO 后续还是要支持指定顺序

          let files = []
          for (let file of this.fileList) {
            if (!file.url) {
              files.push({ id: 0, file: file })
            } else {
              files.push(file)
            }
          }

          if (this.local_files && this.local_files.length) {
            for (let file of this.local_files) {
              files.push({ id: 0, file: file })
            }
          }

          query = DBUtil.editMemo({
            slug: vm.memo_slug,
            content: content,
            source: vm.is_mobile ? 'mobile' : 'web',
            file_ids: vm.file_ids, //[3983640]
            files: files,
          })
        }
      }

      if (query) {
        query
          .then((result) => {
            if (result && result.name == 'AbortError') {
              console.log(result)
              this.loading = false
              this.$message.error(this.$t('fleditor.message.abort_error'))
            } else if (result && result.name == 'MemoNotFound') {
              console.log(result)
              this.loading = false
              this.$message.error(result.message)
            } else if (result) {
              if (vm.isTray) {
                vm.editor.commands.setContent('')
              }
              vm.$emit('memo-updated', {
                ...result,
                files: vm.fileList,
              })
              vm.loading = false

              vm.file_ids = []
              if (vm.$refs.upload) {
                vm.$refs.upload.clearFiles()
              }
              vm.files_show = false
              vm.local_files = []
              vm.fileList = []
              vm.pasteImages = []
            }
            vm.isFocused = false
          })
          .catch((error) => {
            this.$message.error(error.message)
            this.loading = false
          })
      }
      if (this.draftKey) {
        localStorage.removeItem(this.draftKey)
      }

      vm.$store.commit('setEditMemoSlug', '')
      if (!vm.memo_slug) {
        vm.focus()
      }
    },
    onClose() {
      if (this.isTray) {
        return window.ipcRenderer.send('closeTrayWindow', true)
      }
    },
    onCancel() {
      this.$store.commit('setEditMemoSlug', '')
      this.$emit('cancel-button-clicked')
    },
    focus() {
      setTimeout(() => {
        this.editor.commands.focus()
      }, 300)
    },
    setContent(content) {
      this.$refs.editor.commands.setContent(content)
    },
    // Image BEGIN
    uploadFile() {
      this.$refs.upload.$el.querySelector('input').click()
      if (this.isTray) {
        window.ipcRenderer.send('pin', true)
      }
    },
    onPasteUpload(e) {
      const upload = this.$refs.upload
      if (!upload) return
      const items = e.clipboardData.items
      let isPasteHandler = false
      // 是否是图片
      let isImage = false
      let isWord = false
      // 把items 里的图片抽出来
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        const htmlContent = (e.originalEvent || e).clipboardData.getData('text/html')

        // 判断是不是word文档
        if (htmlContent && htmlContent.indexOf('microsoft-com:office') > -1) {
          isWord = true
          continue
        }

        if (item.kind === 'file' && item.type.match(/^image\//i) && !isWord) {
          const imgType = item.type.split('/')[1]
          const imageName = `${new Date().getTime()}.${imgType || 'png'}`
          isImage = true
          if (this.pasteImages.length >= 9 || this.file_ids.length >= 9) {
            this.onExceedFileLimit()
            return
          }

          const file = new File([item.getAsFile()], imageName, {
            type: item.type || 'image/png',
          })

          this.pasteImages.push(file)
          upload.handleStart(file)
        }
      }

      // fix bug: 从微信复制图片粘贴到编辑器，会把图片地址粘贴到编辑器里
      if (isImage) {
        upload.submit()
        e.preventDefault()
        isPasteHandler = true
        return
      }

      for (const item of items) {
        if (e.clipboardData && !isImage) {
          let content = (e.originalEvent || e).clipboardData.getData('text/plain')
          let htmlContent = (e.originalEvent || e).clipboardData.getData('text/html')
          if (htmlContent == null || htmlContent.length == 0) {
            document.execCommand('insertText', false, content)
            e.preventDefault()
            isPasteHandler = true
          } else {
            //content为空时,可能有其它DataTransferItem.不视为处理完成
            if (content == null || content.length == 0) {
              continue
            }
            //啥也不做 事件正常冒泡 调用默认的粘贴效果
            isPasteHandler = true
          }
        } else if (window.clipboardData) {
          let content = window.clipboardData.getData('Text')
          document.selection.createRange().pasteHTML(content)
          e.preventDefault()
          isPasteHandler = true
        }

        if (isPasteHandler) break
      }
    },
    dataURItoBlob(dataURI, type) {
      var binary = atob(dataURI.split(',')[1])
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], { type: type })
    },
    async getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const objectURL = URL.createObjectURL(file)
        img.onload = () => {
          URL.revokeObjectURL(objectURL)
          resolve({ width: img.width, height: img.height })
        }
        img.onerror = () => {
          URL.revokeObjectURL(objectURL)
          reject(new Error('Failed to load image'))
        }
        img.src = objectURL
      })
    },

    async handleBeforeFileUpload(file) {
      if (this.file_ids.length >= 9) {
        this.onExceedFileLimit()
        return false
      }
      let isImage = file.type.includes('image')
      let temp = file.name.split('.')
      let suffix = temp[temp.length - 1]

      if (suffix.toUpperCase() == 'PSD' || suffix.toUpperCase() == 'HEIC' || suffix.toUpperCase() == 'HEIF') {
        this.$message.error(this.$t('fleditor.message.unsupport_file_type'))
        return Promise.reject()
      }

      if (!isImage) {
        this.$message.error(this.$t('fleditor.message.only_upload_image'))
        return Promise.reject()
      }

      this.files_show = true

      // 判断图片的height是否大于16000px，如果大于则不上传

      try {
        const dimensions = await this.getImageDimensions(file)
        console.log(`Width: ${dimensions.width}, Height: ${dimensions.height}`)
        const { width, height } = dimensions
        if (width > 16000 || height > 16000) {
          this.$message.error(this.$t('fleditor.message.image_too_large'))
          return Promise.reject()
        }
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('fleditor.message.image_not_found'))
        return Promise.reject()
      }

      // 如不需压缩，直接返回
      if (!this.needCompress) {
        return file
      }

      const vm = this
      const maxWidth = 1200
      return new Promise((resolve) => {
        const reader = new FileReader()
        const image = new Image()
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          const width = Math.min(image.width, maxWidth)
          const height = (width / image.width) * image.height
          canvas.width = width
          canvas.height = height
          context.clearRect(0, 0, width, height)
          context.drawImage(image, 0, 0, width, height)
          const dataUrl = canvas.toDataURL(file.type)
          const blobData = vm.dataURItoBlob(dataUrl, file.type)
          console.log('saveLocalFile')
          resolve(blobData)
        }
        reader.onload = (e) => {
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    handleFileUpload(param) {
      let vm = this
      if (this.file_ids.length >= 9) {
        return false
      }

      param.file.status = 'uploading'
      if (!this.$store.state.isOnLine) {
        console.log('无网,不用上传', param)
        //TODO 数据放local_files里
        const reader = new FileReader()
        reader.addEventListener('loadend', function () {
          // reader.result 包含转化为类型数组的blob
          // console.log(param);
          // param.blob = reader.result;
          vm.fileList.push(param.file)
          // console.log(reader)
        })
        reader.readAsArrayBuffer(param.file)
        return
      }
      param.file.progress = 30
      vm.fileList.push(param.file)
      DBUtil.uploadFile(param, (file, error) => {
        param.file.percentage = 100
        //TODO 上传成功后 给 el-uplado里的对象绑一个标记 等会删除的时候要用
        // for(let el_file of vm.$refs.upload.uploadFiles){
        // 	if(file.name == el_file.name){
        // 		el_file.id = file.id;
        // 	}
        // }
        param.onSuccess(file)
        if (file) {
          vm.file_ids.push(file.id)
        } else {
          vm.$message.error(error)
        }
      })

      if (this.isTray) {
        if (!this.$store.state.trayPinned) {
          window.ipcRenderer.send('pin', false)
        }
      }
    },
    handleFileUploadSuccess(res, file, fileList) {
      this.fileList.forEach((element, index) => {
        if (element.uid === file.uid) {
          element = {
            ...element,
            id: file.response.id,
            ...file.response,
            progress: 100,
            ...file,
          }

          this.$set(this.fileList, index, element)
        }
      })

      // this.file_ids.push(res.file.id);
    },
    // 没有调用，实际调用了 -> handleRemoveFile
    beforeFileRemove(file, fileList) {
      if (file.id) {
        let index = this.file_ids.indexOf(file.id)
        this.file_ids.splice(index, 1)
      } else {
        let index = fileList.indexOf(file)
        this.file_ids.splice(index, 1)
      }
      this.local_files = this.local_files.filter((item) => item.name !== file.name)
      this.pasteImages = this.pasteImages.filter((item) => item.name !== file.name)

      // 当没有文件时不展示文件列表(即不展示上传icon)
      if (!this.$store.state.isOnLine) {
        if (!this.local_files.length) {
          this.files_show = false
        }
      } else {
        if (!this.file_ids.length) {
          this.files_show = false
        }
      }
      return true
    },
    handlePictureCardPreview(file) {
      if (!this.$store.state.isOnLine) {
        this.$message.error(this.$t('tooltips.offline_image'))
        return
      }
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    onExceedFileLimit() {
      this.$message.error(this.$t('fleditor.on_exceed_file_limit'))
    },
    // Image END

    // HashTag BEGIN
    // renderPopup(node) {
    //   if (this.hashtag.popup || node == null) return
    //   this.hashtag.popup = tippy('.editor-content', {
    //     getReferenceClientRect: node.getBoundingClientRect,
    //     appendTo: () => document.body,
    //     interactive: true,
    //     content: this.$refs.suggestions,
    //     trigger: 'focusin', //'mouseenter', // manual
    //     showOnCreate: true,
    //     theme: 'dark',
    //     placement: 'bottom-start',
    //     inertia: true,
    //     duration: [400, 200],
    //   })
    // },
    // destroyPopup() {
    //   if (this.hashtag.popup) {
    //     this.hashtag.popup[0].destroy()
    //     this.hashtag.popup = null
    //   }
    // },
    // selectTag(tag) {
    //   if (!tag) return
    //   this.hashtag.insertMention({
    //     range: this.hashtag.suggestionRange,
    //     attrs: {
    //       label: tag,
    //     },
    //   })
    //   this.editor.commands.focus()
    // },

    handleRemoveFile(file) {
      //删除file_ids中对应的id   如果是刚上传的,实际这里返回是 el-upload里的file结构对象 没有id字段的，改用 uid
      if (!this.$store.state.isOnLine) {
        this.fileList = this.fileList.filter((item) => item.id !== file.id)
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter((item) => item.uid !== file.uid)
        this.pasteImages = this.pasteImages.filter((item) => item.uid !== file.uid)
      } else {
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter((item) => item.uid !== file.uid)
        this.fileList = this.fileList.filter((item) => item.id !== file.id)
        this.pasteImages = this.pasteImages.filter((item) => item.uid !== file.uid)
      }

      this.file_ids = this.file_ids.filter((item) => item != file.id)

      if (!this.file_ids.length && !this.$refs.upload.uploadFiles.length) {
        this.files_show = false
      }
    },

    blobToUrl(blob) {
      if (blob.url) {
        return blob.url
      }
      if (blob.file) {
        return window.URL.createObjectURL(blob.file)
      }
      return window.URL.createObjectURL(blob)
    },

    onDropUpload(e) {
      const upload = this.$refs.upload
      if (!upload) return
      const dragFiles = e.dataTransfer.files
      for (let i = 0; i < dragFiles.length; i++) {
        const item = dragFiles[i]

        if (item.type.match(/^image\//i)) {
          if (this.pasteImages.length > 8) {
            this.onExceedFileLimit()
            return
          }
          this.pasteImages.push(item)
          upload.handleStart(item)
        }
      }

      upload.submit()
    },

    // insert # text
    insertTagText() {
      let content = this.editor.getHTML()
      // 去掉所有html tag
      content = content.replace(/<[^>]*>/g, '')

      this.editor
        .chain()
        .focus()
        .insertContent(content.length ? ' #' : '#')
        .run()
    },

    addRelation() {
      let content = this.editor.getHTML()
      // 去掉所有html tag
      content = content.replace(/<[^>]*>/g, '')

      this.editor
        .chain()
        .focus()
        .insertContent(content.length ? ' @' : '@')
        .run()
    },

    addNewLine() {
      //this.editor.commands.setHardBreak()
      this.editor.commands.enter()
    },

    onSubmitByHotkey(key) {
      let saveKey = this.$store.state.hotkeys.filter((item) => item.action == 'save')[0].key
      if (saveKey.indexOf(key) > -1) {
        this.onSubmit()
      }
      if (this.newLineKey.indexOf(key) > -1 && key != 'Enter') {
        this.addNewLine()
      }
    },

    // 滚动列表，输入框收起
    editorToggle() {
      const that = this
      this.$nextTick(() => {
        const memoListDom = document.querySelector('.memos')

        if (!memoListDom) {
          return
        }
        memoListDom.addEventListener('scroll', function (e) {
          const editorDom = document.querySelector('.input .editor-content .ProseMirror')
          if (editorDom && editorDom.style.minHeight != '14px') {
            editorDom.style.cssText = 'min-height: 14px;'
            if (that.calMemosHeight()) {
              that.calMemosHeight()
            }
          }
        })
      })
    },
    // 判断是不是 iphone 和 ipad
    isIphone() {
      const u = navigator.userAgent
      const isIphone = u.indexOf('iPhone') > -1
      const isIpad = u.indexOf('iPad') > -1
      if (isIphone || isIpad) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    // this.$refs.editor.$el.addEventListener('keydown', function (e) {
    //   // 监听回车事件,取消加粗下划线
    //   if (e.keyCode == 13) {
    //     that.editor.commands.unsetBold()
    //     that.editor.commands.unsetUnderline()
    //   }
    // })

    // let _this = this;
    // this.$refs.editor.$el.addEventListener('copy', function(e){
    //     console.log(e);
    //     console.log(document.getSelection().toString());
    //     let doc = document.getSelection().getRangeAt(0).cloneContents();
    //     let text = document.getSelection().toString();
    //     let node = document.createElement('p');
    //     node.appendChild(doc);

    //     console.log(node.innerHTML);

    //     e.clipboardData.setData('text/plain', document.getSelection().toString()); // 剪贴板内容设置

    // });

    let initContent = ''
    if (localStorage.getItem(this.selected_tag)) {
      let tag = localStorage.getItem(this.selected_tag)
      initContent = '#' + tag + ' '
    }
    if (this.draftKey) {
      initContent = localStorage.getItem(this.draftKey)
    }
    if (this.initContent) {
      initContent = this.initContent
    }

    const that = this

    let extensions = [
      Placeholder.configure({
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        placeholder: this.placeholder,
        showOnlyWhenEditable: true,
        showOnlyCurrent: true,
      }),
      Paragraph,
      Document,
      Text,
      BulletList,
      ListItem,
      History,
      OrderedList,
      Underline.extend({
        addKeyboardShortcuts() {
          return {
            Enter: () => {
              that.editor.commands.unsetUnderline()
            },
            'Mod-u': () => this.editor.commands.toggleUnderline(),
            'Mod-U': () => this.editor.commands.toggleUnderline(),
          }
        },
      }),
      Bold.extend({
        addKeyboardShortcuts() {
          return {
            'Mod-b': () => this.editor.commands.toggleBold(),
            'Mod-B': () => this.editor.commands.toggleBold(),
            Enter: () => {
              that.editor.commands.unsetBold()
            },
          }
        },
      }),
      Highlight,
      Relation.configure({
        HTMLAttributes: {
          class: 'relation',
        },
        relation,
      }),
    ]

    if (!this.isIphone()) {
      extensions.push(
        Mention.extend({
          addKeyboardShortcuts() {
            return {
              Backspace: () =>
                this.editor.commands.command(({ tr, state }) => {
                  let isMention = false
                  const { selection } = state
                  const { empty, anchor } = selection
                  state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
                    if (node.type.name === this.name) {
                      isMention = true
                      // tr.insertText(this.options.suggestion.char || '', pos, pos + node.nodeSize)
                      tr.insertText(
                        this.options.suggestion.char + node.attrs.id.slice(0, node.attrs.id.length - 1),
                        pos,
                        pos + node.nodeSize,
                      )
                      return false
                    }
                  })

                  return isMention
                }),
            }
          },
        }).configure({
          HTMLAttributes: {
            class: 'mention',
          },
          suggestion,
          slug: this.memo_slug,
        }),
      )
    }

    that.editor = new Editor({
      parseOptions: {
        preserveWhitespace: true,
      },
      extensions,
      autoFocus: that.autoFocus,
      content: initContent,
      onUpdate: ({ editor }) => {
        if (!that.draftKey) return
        localStorage.setItem(that.draftKey, editor.getHTML())
        if (that.isTray) {
          that.onUpdate()
        }
      },
      onFocus({ editor }) {
        that.isFocused = true
        that.onFocus()
        const { is_pro, zen_mode } = that.$store.getters
        // 如果是flomo pro且开启了zen模式
        if (is_pro && zen_mode == 'on') {
          that.$store.commit('setFocused', true)
          that.$store.commit('setEditMemoSlug', that.memo_slug)
        }

        logClickEvent('新建MEMO', '输入框激活')

        if (!that.memo_slug) {
          const editorDom = document.querySelector('.input .ProseMirror')
          if (editorDom) {
            editorDom.style.cssText = 'min-height: 92px; transition: min-height 0.2s ease-in-out;'
          }
        }
      },
      onBlur({ editor }) {
        that.isFocused = false
        that.$store.commit('setFocused', false)
        that.onBlur()
      },
      editorProps: {
        handleDOMEvents: {
          drop: (view, e) => {
            e.preventDefault()
            that.onDropUpload(e)
          },
        },
        handlePaste: (view, event) => {
          const hasFiles = event.clipboardData && event.clipboardData.files && event.clipboardData.files.length
          if (!hasFiles) {
            return
          }

          const images = Array.from(event.clipboardData.files).filter((file) => /image/i.test(file.type))
          if (images.length === 0) {
            return
          }

          event.preventDefault()
          that.onPasteUpload(event)
          //   return true
        },
      },
    })
    if (this.initFiles.length) {
      this.file_ids = this.initFiles.map(function (file) {
        return file.id
      })
      this.files_show = true
      this.fileList = this.initFiles
    }

    if (this.autoFocus) {
      //this.editor.state.doc.content中每一行头尾比实际各多一个控制字符(?).
      //默认focus时,selection为0.
      //在此位置插入,实际会插到控制字符前,发生错误后生成了一个新行. 插入末尾同理.
      //修改默认focus时,将selection指向文本末尾-1 即行结束标记前
      this.editor.commands.setTextSelection({
        from: this.editor.state.doc.content.size - 1,
        to: this.editor.state.doc.content.size - 1,
      })
    }
    if (this.is_review) {
      this.$nextTick(() => {
        const files = document.querySelector('.files')

        this.fileResizeObserver = new ResizeObserver((entries) => {
          const ProseMirror = document.querySelector('.ProseMirror')
          const { offsetHeight } = entries[0].target
          if (ProseMirror) {
            ProseMirror.style.maxHeight = 366 - offsetHeight + 'px'
          }
        })

        this.fileResizeObserver.observe(files)
      })
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>
<style scoped>
div.input-box {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  position: relative;
  background: var(--editor-menu-bar-bg);
}

div.input-box:hover {
  border-color: #d3ecdd;
}

.editMemo div.input-box {
  border: 1px solid transparent;
  border-color: transparent !important;
}

.editMemo div.input-box:hover {
  border-color: none;
}

.dark_mode .input-box:hover {
  border: 1px solid var(--green) !important;
}

.dark_mode .editMemo .input-box:hover,
.dark_mode .pinWindow .input-box:hover {
  border: 1px solid transparent !important;
}

.editor-content {
  font-size: 14px;
  padding: 15px;
  color: var(--memoContentColor);
  background: var(--defaultBg);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.editMemo .editor-content {
  padding: 0px;
  padding-bottom: 20px;
}

.editMemo div.editor-menu-bar .pin-left {
  left: 0px;
}

.editor-content /deep/ p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
}

.editor-content /deep/ .ProseMirror {
  min-height: 92px;
  /* max-height: 500px; */
  max-height: calc(50vh);
  overflow-y: scroll;
  transition: min-height 0.3s ease-in;
}

#tray_editor .editor-content /deep/ .ProseMirror {
  min-height: 300px;
}

.tray-text /deep/ .ProseMirror {
  max-height: calc(80vh);
}

.mobile .hasFiles .editor-content /deep/ .ProseMirror {
  max-height: 250px;
}

.editor-content /deep/ .ProseMirror:focus {
  outline: none;
}

.editor-content /deep/ ul,
.editor-content /deep/ ol {
  padding-inline-start: 22px;
  margin: 0;
  margin-bottom: 0.5em;
}

.editor-content /deep/ ul:last-child,
.editor-content /deep/ ol:last-child {
  margin-bottom: 0;
}

.editor-content /deep/ li {
  line-height: 1;
}

.editor-content /deep/ li p {
  margin-bottom: 0;
}

.editor-content /deep/ p {
  line-height: 1.8;
  margin: 0;
  margin-bottom: 0.5em;
  min-height: 25px;
}

.editor-content /deep/ p:last-child {
  margin-bottom: 0;
}

.editor-content /deep/ strong {
  font-weight: 900;
}

.editor-content /deep/ img {
  width: 200px;
}

.files {
  padding: 5px 18px;
}

.files /deep/ .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 78px;
}

.files /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
}

.files /deep/ .el-upload-list--picture-card .el-upload-list__item img.el-image__inner {
  width: 70px;
  height: 70px;
}

.files /deep/ img.el-upload-list__item-thumbnail {
  object-fit: cover;
}

.el-upload-list__item-thumbnail:hover {
  cursor: move;
  background: rgba(00, 00, 00, 0.1);
}

.files /deep/ .el-progress {
  width: 50px;
  margin: 0 auto;
}

div.editor-menu-bar {
  height: 40px;
  background: var(--editor-menu-bar-bg);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 0 15px; */
  /* padding-left: 10px; */
}

div.editor-menu-bar .pin-left {
  position: absolute;
  bottom: 5px;
  left: 15px;
}

div.editor-menu-bar .pin-left svg {
  fill: #9d9d9d;
}

div.editor-menu-bar .pin-left svg:hover {
  fill: #000000;
}

.dark_mode div.editor-menu-bar .pin-left svg:hover {
  fill: #e3e3e3;
}

div.editor-menu-bar .pin-right {
  position: absolute;
  bottom: 10px;
  right: 0px;
  display: flex;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.actions .svg-icon {
  margin: 0 9px;
  cursor: pointer;
  color: var(--svgActiveColor);
}

.actions .is-disabled {
  color: var(--svgDisableColor);
}

div.editor-menu-bar .el-button + .el-button {
  margin-left: 3px;
}

div.editor-menu-bar .el-button--text,
div.editor-menu-bar .el-button--text.is-active {
  color: #7d7d7d;
  border-color: transparent;
  padding: 0px 5px;
}

div.editor-menu-bar .el-button--text.is-active {
  color: black;
}

div.editor-menu-bar .el-button--text.is-active svg {
  color: var(--editorActiveColor);
  background: var(--hoverBg);
}

div.editor-menu-bar .submit-btn {
  color: #fff;
  background: #55bb8e;
  border-color: #55bb8e;
  font-size: 12px;
}

div.editor-menu-bar .submit-btn:disabled {
  background: #aaddc6;
  border-color: #aaddc6;
}

.hashtag {
  background: rgba(00, 00, 00, 0.1);
  color: rgba(00, 00, 00, 0.6);
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
}

.hashtag-suggestion {
  color: rgba(00, 00, 00, 0.6);
}

.cancel-btn {
  border-color: transparent !important;
  padding: 6px 10px;
  margin-right: 10px;
  color: #9d9d9d;
  background: var(--cancel-btn-bg);
}

.cancel-btn:hover {
  background-color: var(--cancel-btn-hover-bg);
  color: #9d9d9d;
}

.dragArea {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  flex-direction: row;
}

.flip-list-move {
  transition: transform 0.3s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.uploadBtn {
  border: none !important;
  border-radius: 6px !important;
}

.files .el-image {
  margin-top: 0px;
  border: none !important;
}
</style>
<style>
.tippy-box[data-theme~='dark'] {
  background-color: rgba(0, 0, 0, 0.9);
  padding: 0;
  font-size: 1rem;
  text-align: inherit;
  color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 16px #dddddd;
}

.ProseMirror-selectednode {
  border-radius: 2px;
  box-shadow: #55bb8e 0px 0px 0px 2px;
  width: 98%;
}

.saveBtn {
  fill: var(--green);
}

.saveBtn:hover {
  fill: #8ddeb5;
}

.focused {
  border: 1px solid var(--green) !important;
  box-shadow: 0px 2px 10px var(--focused-shadow-bg);
}

.blurd {
  border: 1px solid var(--blurd-border-color) !important;
  box-shadow: 0px 2px 10px var(--blurd-shadow-color);
}

.disableSave,
.saveBtn {
  margin-right: 15px;
}

.disableSave rect {
  fill: var(--editorColor);
}

.disableSave path {
  fill: white;
}

.focused .disableSave rect {
  fill: var(--focus-disabled);
}

body.dark_mode .disableSave path {
  fill: #9d9d9d;
}

.memo .ProseMirror {
  max-height: unset !important;
}

.ProseMirror p u {
  text-underline-offset: 5px;
}

.saveBtn rect {
  fill: var(--green);
}

.saveBtn path {
  fill: var(--saveSvgPathColor);
}

.saveBtn:hover rect {
  fill: #2bba6d;
}

li.hide {
  display: none;
}

.ProseMirror {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
<style scoped lang="scss">
.bubble-menu {
  background: var(--glassBg);
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
  border: 0.5px solid var(--fuzzy-border);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  visibility: visible !important;

  .wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 296px;
    box-sizing: border-box;
    border: 0.5px solid var(--glass-inner-border);
    border-radius: 4px;

    button {
      display: inline-block;
      margin: 0 5px;
      border: none;
      background: none;
      height: 28px;
    }

    svg {
      padding: 5px;
      cursor: pointer;
      border-radius: 3px;

      &:hover {
        color: var(--editorActiveColor);
        fill: var(--editorActiveColor);
        background: var(--hoverBg);
      }
    }

    .is-active {
      svg {
        color: var(--editorActiveColor);
        background: var(--hoverBg);
      }
    }
  }
}

.floatMenu {
  border: 0.5px solid var(--glass-inner-border);
  padding: 5px 0px;
  border-radius: 4px !important;
}

.toolMenu {
  display: flex;
  justify-content: center;
  align-items: center;

  .hashTag {
    margin-left: -5px;
  }

  svg {
    padding: 5px;
    cursor: pointer;
    // margin: 0 2px;
    border-radius: 3px;
    color: var(--editorColor);

    &:hover {
      color: var(--editorActiveColor);
      fill: var(--editorActiveColor);
      background: var(--hoverBg);
    }
  }

  .is-active {
    svg {
      fill: var(--editorActiveColor);
      color: var(--editorActiveColor);
    }
  }
}

.focused {
  .toolMenu {
    svg {
      color: #9d9d9d;
    }
  }
}

#app .toolMenu svg {
  margin: 0 -5px;
}
</style>
<style>
.vertical-line {
  width: 1px !important;
  height: 16px !important;
  background: var(--editorColor);
  margin: 10px !important;
  display: inline-block;
}

#app .vertical-line {
  margin: 10px 5px;
}

blockquote {
  padding-left: 10px;
  border-left: 2px solid var(--blockquote-bg);
  margin-bottom: 0.5em;
}

blockquote p,
blockquote li {
  line-height: 1.5em !important;
}

s {
  color: rgba(157, 157, 157, 1);
}

mark {
  background: var(--mark-bg);
  color: var(--memoContentColor);
  padding: 1px 0 2px;
}
</style>
<style>
.toolMenuPopover {
  border-radius: 4px !important;
  backdrop-filter: blur(20px) !important;
  margin: 0px;
  width: 110px !important;
  min-width: unset !important;
  box-sizing: border-box;
  box-shadow: none !important;
  background: var(--glassBg);
  border: 0.5px solid var(--fuzzy-border) !important;
  padding: 0px !important;
}

.toolMenuPopover span {
  display: inline-block;
  width: 28px;
  height: 28px;
  margin: 0 2.5px !important;
}

.toolMenuPopover svg {
  color: #9d9d9d !important;
}

.toolMenuPopover svg:hover {
  color: var(--editorActiveColor) !important;
}

body.dark_mode div.display:hover,
body.dark_mode .blurd,
body.dark_mode .focused,
body.dark_mode .foldList:hover {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.2) !important;
}

body.dark_mode .input .blurd,
body.dark_mode .input .focused {
  box-shadow: unset !important;
}
</style>
